// @flow

import { useMemo } from 'react';
import { useMutation } from 'react-query';
import { generateStandardFilename } from '@fortress-technology-solutions/fortress-component-library/utils';

import Rd356010FormService from '../../services/rd356010FormService';

// Renders the 3560-10 PDF + MINC XML zip from the edited form and saves it.
// The backend names the zip like the 3560-10 report does; the standard
// filename is only the fallback when no Content-Disposition comes back.
const useGenerateRd356010Mutation = ({
  organizationId,
  propertyId,
  propertyName,
  options = {},
}: {
  organizationId: string,
  propertyId: string,
  propertyName: string,
  options?: Object,
}) => {
  const service = useMemo(() => new Rd356010FormService(), []);

  return useMutation(
    ['rd-3560-10-generate', organizationId, propertyId],
    (form: Object) => {
      const fileName = generateStandardFilename({
        type: '3560-10',
        descriptor: propertyName || 'Property',
        extension: 'zip',
      });
      return service.generate(organizationId, propertyId, form, fileName);
    },
    options,
  );
};

export default useGenerateRd356010Mutation;
